import { getOuterBlobHeight } from './blobUtils';
import { OuterBlob } from './BlobPaths';
import { BlobSvg } from './Blob.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OuterSvg = ({
  children,
  color,
  messageKey
}) => {
  const outerBlobHeight = getOuterBlobHeight(messageKey);
  return /*#__PURE__*/_jsxs(BlobSvg, {
    "aria-hidden": "true",
    height: outerBlobHeight,
    viewBox: OuterBlob.viewBox,
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: OuterBlob.path,
      fill: color,
      transform: OuterBlob.transform
    }), children]
  });
};